import { defineComponent as _defineComponent } from 'vue';
import ActivitySettings from "@/components/ActivityBar/ActivitySettings.vue";
import ActivityPanel from "@/components/Panels/ActivityPanel.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SettingsPanel',
    setup(__props) {
        return { __sfc: true, ActivitySettings, ActivityPanel };
    }
});
